'use client';

import {Button, ButtonProps, Container, styled, Typography} from '@mui/material';
import {StyledSectionContainer} from '@/components/sections/shared/Section.styles';

export const StyledInformationLinkButtonSectionInnerContainer = styled(Container)(({theme}) => ({
  backgroundColor: theme.palette.background.lightGrey,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  color: theme.palette.text.dark,
}));

export const StyledInformationLinkButtonSectionContainer = styled(StyledSectionContainer)(({theme}) => ({
  backgroundColor: theme.palette.background.lightGrey,
}));


export const StyledInformationLinkButtonContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  marginTop: theme.spacing(1),
  width: 'fit-content',
  gridTemplateColumns: 'repeat(2, 1fr)',
  // If there's only one child, let it span all columns and center it
  '& > *:only-child': {
    gridColumn: '1 / -1',
    justifySelf: 'center',
  },
  [theme.breakpoints.down('xs')]: {
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: theme.spacing(2),
    // single child behavior still applies on small screens
    '& > *:only-child': {
      gridColumn: '1 / -1',
      justifySelf: 'center',
    },
  },
}));

export const StyledInformationLinkButtonMediaContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  aspectRatio: '16 / 9',
  maxHeight: 400,
  margin: theme.spacing(0, 0, 4,0),
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadiusLg,
}));

export const StyledInformationLinkButtonHeading = styled(Typography)(({theme}) => ({
  marginBottom: theme.spacing(3),
  paddingLeft: theme.spacing(6),
  paddingRight: theme.spacing(6),
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export const StyledInformationLinkButtonBreadTextContainer = styled('div')(({theme}) => ({
  paddingLeft: theme.spacing(6),
  paddingRight: theme.spacing(6),
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export const StyledInformationLinkButton = styled(Button)<ButtonProps<'a'>>(() => ({}));
